"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSubsidiary = exports.isSubsidiary = exports.SubsidiaryId = exports.Subsidiary = void 0;
exports.getSubsidiaryValueById = getSubsidiaryValueById;
exports.Subsidiary = {
    NL: 'nl',
    BE: 'be',
    DE: 'de',
};
/**
 * @deprecated
 * Please use Subsidiary instead, we want to migrate from Id's to Subsidiary objects
 */
var SubsidiaryId;
(function (SubsidiaryId) {
    SubsidiaryId[SubsidiaryId["NL"] = 1] = "NL";
    SubsidiaryId[SubsidiaryId["BE"] = 3] = "BE";
    SubsidiaryId[SubsidiaryId["DE"] = 5] = "DE";
})(SubsidiaryId || (exports.SubsidiaryId = SubsidiaryId = {}));
const isSubsidiary = (value) => Object.values(exports.Subsidiary).some((subsidiary) => subsidiary === value);
exports.isSubsidiary = isSubsidiary;
const parseSubsidiary = (value) => {
    const lowercaseValue = value.toLowerCase();
    return (0, exports.isSubsidiary)(lowercaseValue) ? lowercaseValue : undefined;
};
exports.parseSubsidiary = parseSubsidiary;
/**
 * @deprecated
 * Please use Subsidiary instead, you can transform your data with this function and remove Id's from your code
 */
function getSubsidiaryValueById(id) {
    return exports.Subsidiary[SubsidiaryId[id]];
}
